"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "polesine-zibello": {
    "788bb4cc": [{
      "hkey": "18217be3",
      "slug": "polesine-parmense",
      "name": "Polesine Parmense",
      "primary": true,
      "skipSearch": false
    }],
    "polesine": [{
      "hkey": "18217be3",
      "slug": "polesine-parmense",
      "name": "Polesine Parmense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "polesine-zibello"
    }],
    "0a8a9e28": [{
      "hkey": "b961a785",
      "slug": "polesine-zibello",
      "name": "Polesine Zibello",
      "primary": true,
      "skipSearch": false
    }],
    "santa-franca": [{
      "hkey": "b961a785",
      "slug": "polesine-zibello",
      "name": "Polesine Zibello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;